import styled from "@emotion/styled";
import { Sidebar } from "./Sidebar";

const Container = styled.div(() => ({
  paddingLeft: "220px",
  backgroundColor: "#F3F4F7",
  minHeight: "100vh",
}));

export const DefaultLayout = ({ children }: any) => {
  return (
    <>
      <Sidebar />
      <Container>{children}</Container>
    </>
  );
};
